export default "__VITE_ASSET__3$rVYMep__"